<div class="card-plain mb-4">
  <div (click)="isCollapsed = !isCollapsed" class="progress-header">
    <div class="d-flex flex-row justify-content-between">
      <p class="mb-2">
        {{ 'ESB_' +commandProgress.progressInfo.messageType | translate }}
        <i class="now-ui-icons mt-1 mr-2" [ngClass]="statusIcon()"></i>
      </p>
      <p class="">{{status}}</p>
    </div>
    @if (commandProgress.progressInfo.isFailure) {
      <p class="text-danger">{{ commandProgress.progressInfo.commandResult }}</p>
    }
    @if (!!commandProgress.progressInfo.exception) {
      <p>Exception: <span class="text-danger ml-4">{{ commandProgress.progressInfo.exception }}</span></p>
    }
  </div>
  <div #childView="ngbCollapse" class="mt-2" [(ngbCollapse)]="isCollapsed">
    <data-list class="fullwidth-table fullwidth-table-slim mb-0" [noResult]="''"
      [cellProps]="childTableCells" [listItems]="commandProgress.progressInfo.children" [pagination]="false" [showContextMenu]="false">
    </data-list>
  </div>
</div>
